(function($){
  jQuery(document).ready(function() {
    $('.YPClickableBoxes-main_wrapper').slick({
      arrows: false,
      dots: false,
      autoplay: false,
      infinite: true,
      variableWidth: true,
        responsive: [
          {
            breakpoint: 9999,
            settings: 'unslick'
          },
          {
              breakpoint: 1023,
              settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              
              }
          },
          {
              breakpoint: 500,
              settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              }
          },
        ],
    });


      var $slider = $('.YPClickableBoxes-main_wrapper');
      var $progressBar = $('.YPClickableBoxes-progressbar');
      var $progressBarLabel = $( '.slider__label' );

      $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
          var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
          
          $progressBar
          .css('background-size', calc + '% 100%')
          .attr('aria-valuenow', calc );
          
          $progressBarLabel.text( calc + '% completed' );
      });
  });

})(jQuery);